/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const borderColor = '#00519C';

const styles = StyleSheet.create({
	tableContainer: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginTop: 24,
		borderWidth: 1,
		borderColor: '#3778C2',
	},

	container: {
		flexDirection: 'row',
		borderBottomColor: '#00519C',
		backgroundColor: '#00519C',
		color: '#fff',
		borderBottomWidth: 1,
		width: '100%',
		height: 24,
	},

	Id: {
		width: '5%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		fontSize: 12,
		textAlign: 'center'
	},

	Email: {
		width: '24%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		fontSize: 12,
		textAlign: 'center',
	},

	CellPhone: {
		width: '14%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		fontSize: 12,
		textAlign: 'center'
	},

	Profile: {
		width: '14%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		fontSize: 12,
		textAlign: 'center'
	},

	Usertype: {
		width: '14%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		fontSize: 12,
		textAlign: 'center'
	},

	Name: {
		width: '14%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		fontSize: 12,
		textAlign: 'center'
	}
});

const paginate = (array, perPage) => {
	const pages = [];
	for (let i = 0; i < array.length; i += perPage)
		pages.push(array.slice(i, i + perPage));
	return pages;
};

const InvoiceItemsTable = (props) => {
	const itemsPerPage = 10;
	const pages = paginate(props.invoice, itemsPerPage);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<React.Fragment key={pageIndex}>

					{/* Insert break ONLY for pages after the first */}
					{pageIndex > 1 && <View break />}

					{/* Page Section */}
					<View wrap={true}>
						{/* Table Header */}
						<View style={styles.container}>
							<Text style={styles.Id}>Id</Text>
							<Text style={styles.Name}>Name</Text>
							<Text style={styles.Email}>Email</Text>
							<Text style={styles.CellPhone}>Cell Phone</Text>
							<Text style={styles.Usertype}>User Type</Text>
							<Text style={styles.Profile}>Profile</Text>
						</View>

						{/* Table Rows */}
						<InvoiceTableRow data={pageData} />
					</View>

				</React.Fragment>
			))}
		</>

	);
};

export default InvoiceItemsTable;
